import { _decorator, Component, Material } from 'cc';

const { ccclass, property } = _decorator;

@ccclass('MaterialContainer')
export default class MaterialContainer extends Component {
    @property([Material])
    private readonly materials: Material[] = [];
}
